module.exports = __webpack_public_path__ + "media/images/paperclip/large/missing-6674515186a2eff0fa2a31e08ed1ed9b.png";